// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface ICustomerRequestStatusType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class CustomerRequestStatusType implements ICustomerRequestStatusType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns New CustomerRequestStatusType
	**/
    get New(): ICustomerRequestStatusType {
        return this.FromId(1);
    }
    /**
		Returns In Progress CustomerRequestStatusType
	**/
    get InProgress(): ICustomerRequestStatusType {
        return this.FromId(2);
    }
    /**
		Returns Complete CustomerRequestStatusType
	**/
    get Complete(): ICustomerRequestStatusType {
        return this.FromId(3);
    }
    /**
		Returns Cancelled CustomerRequestStatusType
	**/
    get Cancelled(): ICustomerRequestStatusType {
        return this.FromId(4);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'New', displayValue: 'New', description: 'New', sortOrder: 999999, active: true });
        this._dictionary.add('2', { id: 2, value: 'InProgress', displayValue: 'In Progress', description: 'In Progress', sortOrder: 999999, active: true });
        this._dictionary.add('3', { id: 3, value: 'Complete', displayValue: 'Complete', description: 'Complete', sortOrder: 999999, active: true });
        this._dictionary.add('4', { id: 4, value: 'Cancelled', displayValue: 'Cancelled', description: 'Cancelled', sortOrder: 999999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): ICustomerRequestStatusType {
        return this._dictionary[id];
    }

    public FromValue(value: string): ICustomerRequestStatusType {
        var match = this._dictionary.getValues().filter(function(data) {
            return data.value == value;
        });

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): ICustomerRequestStatusType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): ICustomerRequestStatusType[] {
        return this.GetAll().filter(function(data) {
            return data.active;
        });
    }

    public Sort(primaryField, secondaryField, reverse): ICustomerRequestStatusType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = function(path, reverse, primer, then) {
        var get = function(obj, path) {
                if (path) {
                    path = path.split('.');
                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }
                    return obj[path[len]];
                }
                return obj;
            },
            prime = function(obj) {
                return primer ? primer(get(obj, path)) : get(obj, path);
            };

        return function(a, b) {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
